<template>
    <div>
        <div v-if="showCardLimited">
            <refill-card-limited />
        </div>
        <div v-else-if="purchaseComplete">
            <refill-complete />
        </div>
        <div v-else>
            <refill-methods />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import RefillMethods from "@/components/wallet/refill/RefillMethods";
import RefillComplete from "@/components/wallet/refill/RefillComplete";
import RefillCardLimited from "@/components/wallet/refill/RefillCardLimited";

export default {
    computed: {
        showCardLimited() {
            return this.onboardingUser.cardLimited && !this.cardLimitedDismissed;
        },
        ...mapState("wallet", ["purchaseComplete", "cardLimitedDismissed"]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    components: {
        RefillMethods,
        RefillComplete,
        RefillCardLimited,
    },
};
</script>